import styled from "@emotion/styled";
import ContextContainer from './ContextContainer';
import { useEffect, useState } from 'react';

const PaymentTable:React.FC<any> = ({ pay }) => {
  const [ date, setDate ] = useState("")
  const handleDate = () => {

    const dateString: string = pay?.updatedAt;
    const formattedDate = dateString.substring(0, 10); 
    setDate(formattedDate)
  };

  useEffect(() =>{
    handleDate()
  },[pay]);

  return (
    <Container>
      <Date>{date}</Date>
      <Context className="context">
        <span className="Title">정기 구독</span>
        <span className="contents">{pay?.total_price}</span>
      </Context>
    </Container>
  )
};

export default PaymentTable;

const Container = styled.div`
  width: 100%;
  height: 71px;
  margin-bottom: 57px;
`;

const Date = styled.div`
  height: 38px;
  padding: 0 6px;
  font-family: 'Pretendard';
  font-style: normal;
  font-weight: 400;
  font-size: 13px;
  line-height: 26px;
`

const Context = styled(ContextContainer)`
  display: flex;
  height: 45px;
  flex-direction: row;
  justify-content: space-between;
  
  &.context {
    padding:0;
    background-color: rgba(250, 250, 250, 1);
  }

  span {
    &.Title{
      /* color:rgba(99, 99, 99, 1); */
      color:rgba(178, 178, 178, 1);
      font-family: 'Pretendard';
      font-style: normal;
      font-weight: 400;
      font-size: 13px;
      line-height: 26px;
      margin-top: 9px;
      margin-left: 16px;
    }
    &.contents{
      margin-right: 23px;
      font-family: 'Pretendard';
      font-style: normal;
      font-weight: 700;
      font-size: 13px;
      line-height: 26px;
      text-align: right;
      color: #191919;
      margin-top: 9px;
    }
  }
`